var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9376 58.5556V57.1536C39.9376 51.6487 35.6134 47.1445 30.3282 47.1445C25.0431 47.1445 20.7189 51.6486 20.7189 57.1536V58.5703",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0283 47.0982C33.9878 46.7104 36.0727 43.9969 35.6849 41.0374C35.2972 38.0778 32.5837 35.993 29.6241 36.3807C26.6646 36.7684 24.5797 39.482 24.9674 42.4415C25.3552 45.401 28.0687 47.4859 31.0283 47.0982Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9543 47.1272C52.9306 46.9012 55.1602 44.3053 54.9342 41.329C54.7083 38.3528 52.1123 36.1232 49.1361 36.3492C46.1598 36.5751 43.9302 39.171 44.1562 42.1473C44.3822 45.1236 46.9781 47.3531 49.9543 47.1272Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3282 31.6472H1.5V36.3346H30.3282V31.6472Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1991 44.5376H20.629",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 36.9204V59.1561H59.1561V57.1535C59.1561 51.6486 54.8319 47.1444 49.5468 47.1444C44.2616 47.1444 39.9374 51.6485 39.9374 57.1535",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9527 5.21003C50.3119 5.67445 51.5505 6.39901 52.6092 7.32432L56.0315 5.82491L59.1564 11.2374L56.1485 13.4502C56.2822 14.1337 56.3529 14.8398 56.3529 15.5624C56.3529 16.285 56.2824 16.9911 56.1485 17.6745L59.1564 19.8873L56.0315 25.2998L52.6092 23.8004C51.5505 24.7256 50.312 25.4504 48.9527 25.9147L48.5403 29.6249H42.2906L41.8783 25.915C40.5189 25.4506 39.2803 24.726 38.2216 23.8006L34.7995 25.2999L31.6746 19.8874L34.6826 17.6745C34.5489 16.9911 34.478 16.285 34.478 15.5625C34.478 14.8398 34.5486 14.1337 34.6824 13.4503L31.6746 11.2374L34.7995 5.82491L38.2217 7.32432C39.2805 6.39913 40.5189 5.67433 41.8783 5.21003L42.2904 1.5H48.5403L48.9527 5.21003ZM45.4155 11.6563C47.5728 11.6563 49.3217 13.4051 49.3217 15.5625C49.3217 17.7199 47.5729 19.4687 45.4155 19.4687C43.2581 19.4687 41.5093 17.7199 41.5093 15.5625C41.5093 13.4051 43.2581 11.6563 45.4155 11.6563Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7799 21.4274C17.6934 20.2206 19.0769 16.8803 17.8701 13.9668C16.6632 11.0533 13.323 9.66972 10.4095 10.8766C7.49592 12.0834 6.11238 15.4237 7.31923 18.3372C8.52608 21.2507 11.8663 22.6343 14.7799 21.4274Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7767 31.0615V25.1063M19.7767 25.1063L19.7794 25.1093C19.7784 25.1083 19.7775 25.1073 19.7767 25.1063ZM19.7767 25.1063C22.0646 24.1108 24.1051 22.6646 25.7813 20.8846C26.6662 19.9442 26.6211 18.4645 25.6807 17.5796C24.7403 16.6947 23.2605 16.7398 22.3757 17.6803C21.1161 19.0177 19.5978 20.0969 17.9089 20.8295C16.2913 21.5314 14.4945 21.9209 12.594 21.9209C8.64365 21.9209 5.41162 25.153 5.41162 29.1033V31.0614",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.985281a35b7b4b9b64729c2e2424a8c4.svg";
export { ForwardRef as ReactComponent };